module.exports = __webpack_public_path__ + "static/media/malanesia_boat_landscape.311c7dc7.psd";